import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [company, setCompany] = useState(null);
  const [ready, setReady] = useState(false);

  const loadCompany = async () => {
    try {
      const { data } = await api.get("/company/profile");
      setCompany(data);
    } catch {
      setCompany(null);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        loadCompany();
      } catch {
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // Two-factor required: don't set user yet, let the caller drive step 2
    if (data?.twofa_required) {
      return data;
    }
    setUser(data);
    loadCompany();
    return data;
  };

  const loginVerify2FA = async (twofa_token, code) => {
    const { data } = await api.post("/auth/2fa/login", { twofa_token, code });
    setUser(data);
    loadCompany();
    return data;
  };

  const switchCompany = async (companyId) => {
    const { data } = await api.post(`/companies/${companyId}/switch`);
    window.location.assign("/dashboard");
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, company, login, loginVerify2FA, logout, setUser, switchCompany, loadCompany }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
